import { render } from "./lCrumbName.vue?vue&type=template&id=404baca0&ts=true"
import script from "./lCrumbName.vue?vue&type=script&lang=ts"
export * from "./lCrumbName.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__